export const SAVE_REPORT_LABEL = 'Save Report';
export const DOWNLOAD_LABEL = 'Download';
